<template>
  <button
    class="sidebar-minimizer"
    type="button"
    @click="
      sidebarMinimize();
      brandMinimize();
    "
  ></button>
</template>
<script>
export default {
  name: "sidebar-minimizer",

  data: () => ({
    mainApp: null
  }),

  mounted() {
    this.mainApp = document.getElementById("main-app");
    this.sidebarMinimize(!!this.$route.meta.quiet);
  },

  methods: {
    sidebarMinimize(value) {
      this.mainApp.classList.toggle("sidebar-minimized", value);
    },
    brandMinimize() {
      this.mainApp.classList.toggle("brand-minimized");
    }
  },

  watch: {
    "$route.meta.quiet"(value) {
      this.sidebarMinimize(value);
    }
  }
};
</script>
